export default "__VITE_PUBLIC_ASSET__890d554f__"